import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/services/$slug")({
  head: () => ({ meta: [{ title: "Edit Service | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-services-slug")),
});
